import React from 'react';
import { useTranslate } from 'react-admin';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';

import Chip from '@material-ui/core/Chip';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LockIcon from '@material-ui/icons/Lock';

import VeenguIcon from '~/components/VeenguIcon';
import { useStyles } from '~/hooks/useLayoutMenuStyles';
import { l, Badge } from '~/types/layoutMenu';
import { isPathMatch } from '~/utils/layoutMenu';

type MenuItemProps = {
  path: string;
  label: string;
  icon: JSX.Element;
  disabled?: boolean;
  badge?: Badge;
  onClick?: () => void;
  shortLabelKey?: string;
  sidebarOpen?: boolean;
  exact?: boolean;
};

const MenuItem = (props: MenuItemProps) => {
  const { path, label, icon, disabled, badge, onClick, shortLabelKey, sidebarOpen, exact } = props;
  const history = useHistory();
  const location = useLocation();
  const translate = useTranslate();
  const t = (key: string, options?: any): string => translate(l(key), options);
  const classes = useStyles({});

  const isRail = !sidebarOpen;
  const displayLabel = t(shortLabelKey || label);

  return (
    <ListItem
      button
      disabled={disabled}
      onClick={(e: any) => {
        history.push(path);
        onClick && onClick();
        e.preventDefault();
      }}
      component='a'
      selected={isPathMatch(path, location.pathname, exact)}
      href={path}
      className={isRail ? classes.railItem : classes.menuItem}
    >
      <ListItemIcon className={isRail ? classes.railIcon : undefined}>{icon}</ListItemIcon>
      {isRail ? (
        <span className={classes.railLabel}>{displayLabel}</span>
      ) : (
        <>
          <ListItemText primary={t(label)} primaryTypographyProps={{ noWrap: true }} />
          {badge === 'notLicensed' && (
            <Chip
              size='small'
              icon={<VeenguIcon name='gem' style={{ fontSize: 12 }} />}
              label={t('addOn')}
              className={classes.notLicensedChip}
            />
          )}
          {badge === 'notAvailable' && <LockIcon fontSize='small' className={classes.lockIcon} />}
          {badge === 'new' && <Chip size='small' label={t('new')} className={classes.newChip} />}
        </>
      )}
    </ListItem>
  );
};

export default MenuItem;
